import {
  useMenuStore,
  useUserStore,
  useUsersStore,
  useDropdownStore,
  useSalesOfficesStore,
} from 'src/stores'

export function useResetStores() {
  const { clear } = useDropdownStore()
  const { clearUser } = useUserStore()
  const { resetMenu } = useMenuStore()
  const { resetUsers } = useUsersStore()
  const { resetSalesOffices } = useSalesOfficesStore()

  const resetStores = () => {
    clear()
    clearUser()
    resetMenu()
    resetUsers()
    resetSalesOffices()
  }

  return { resetStores }
}
